module.exports = "https://www.gc-pro.gnp.com.mx/ab8792b7fa7d85a6f150e982a50034d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/pago/2.png
// module id = 1041
// module chunks = 0 1